// @flow
import React from 'react'
import I18n from 'i18n-react'

// components
import { FieldForm, TextForm } from '../../Components/'

// types
import type { DefaultMiniAppProps } from './'

type ChildrenMiniAppProps = DefaultMiniAppProps & {
  isBackOffice?: boolean,
  textMode?: boolean,
}

export const CHILDREN_FORM_CONTENT = (quoteRequest?: boolean = true, textMode?: boolean = false) => ({
  types: {
    policyHolderParty: {
      types: {
        child: {
          types: {},
          fieldOrder: [
            'firstName',
            'lastName',
            'birthNumber'
          ],
          fieldNames: {
            firstName: 'Jméno',
            lastName: 'Přijmení',
            birthNumber: 'Rodné číslo',
          }
        }
      },
      fieldOrder: [
        'numberOfChildren',
        'children',
      ],
      fieldNames: {
        numberOfChildren: 'Dětí do 18 let',
        children: 'Děti',
        childrenArrayTitle: '{value}. dítě',
      },
      components: {
        numberOfChildren: {
          textMode: !quoteRequest,
          textModeClassName: textMode ? '' : 'd-block pt-sm-2 mt-sm-1',
        },
      }
    }
  },
  fieldOrder: [
    'policyHolder'
  ],
  fieldNames: {
    policyHolder: 'Slevy',
  }
})

const ChildrenMiniApp = (props: ChildrenMiniAppProps) => {
  const { fullSpecification, formData, pushIsPristine, validationErrors, inputHelps, miniAppData, arrayTypes, textMode } = props

  if (!fullSpecification || !fullSpecification.fields || miniAppData.quoteRequest === false &&
    (!arrayTypes.children || !arrayTypes.children.length)) {
    return null
  }

  const enabled = fullSpecification.fields.reduce((acc, field) =>
    acc && (field.name !== 'policyHolder' || field.domain.specification.fields.reduce((acc2, f) =>
    acc2 && (f.name !== 'children' || f.enabled), true))
    , true)

  if (!enabled) {
    return null
  }

  let Component = FieldForm
  if (textMode) {
    return (
      <TextForm
        arrayTypes={arrayTypes}
        blockClassName=''
        blockClassNameForR=''
        blockContentClassName=''
        content={CHILDREN_FORM_CONTENT(miniAppData.quoteRequest, textMode)}
        data={formData}
        formData={formData}
        key='childrenMiniAppFieldForm'
        showArrayTypeTitle
        showBlockTitle={false}
        specification={fullSpecification}
      />
    )
  }

  return ([
    miniAppData.quoteRequest === false && <div className='text-center mt-5' key='childrenMiniApp-title'>
      <h2>{I18n.translate('components.discounts.title')}</h2>
    </div>,
    miniAppData.quoteRequest === false &&
    <hr className='border-0 border-sm-top border-active-object' key='childrenMiniApp-hr'/>,
    <Component
      arrayTypes={arrayTypes}
      blockClassName=''
      blockClassNameForR=''
      blockContentClassName=''
      content={CHILDREN_FORM_CONTENT(miniAppData.quoteRequest, textMode)}
      data={formData}
      formData={formData}
      inputHelps={inputHelps}
      key='childrenMiniAppFieldForm'
      onChangeValue={props.onChangeValue}
      prefix='childrenMiniAp'
      pushIsPristine={pushIsPristine}
      showArrayTypeTitle
      showBlockTitle={false}
      specification={fullSpecification}
      validationErrors={validationErrors}
    />
  ])
}

export default ChildrenMiniApp
